<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2><button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>ویرایش یادداشت</h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="150">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
                <div class="card-bg bg-20"></div>
            </div>
            <div class="card card-style">
                <div class="content mb-0">

                    <div>
                        <div class="input-style input-style-2 has-icon input-required">
                            <i class="input-icon fa fa-calendar color-magenta2-light"></i>
                            <span class="color-highlight" :class="{'input-style-1-active' : taskNoteModel.createDateTime!==null}">زمان ثبت</span>
                            <input type="text" class="form-control ltr d-inline-block" v-model="taskNoteModel.createDateTime" id="endDT" />
                        </div>

                    </div>

                    <div class="input-style input-style-2 has-icon input-required">
                        <i class="input-icon fa fa-check color-magenta2-light"></i>
                        <span class="color-highlight" :class="{'input-style-1-active' : taskNoteModel.title!==null}">عنوان</span>
                        <input class="form-control" type="text" v-model="taskNoteModel.title" @input="v$.taskNoteModel.title.$touch()" :class="{invalid:v$.taskNoteModel.title.$error}" @keyup="modified=true">
                        <p class="text-danger" v-if="v$.taskNoteModel.title.required.$invalid && v$.taskNoteModel.title.$dirty">لطفا عنوان را وارد کنید.</p>
                    </div>
                    <div class="mb-3">
                        <div class="d-flex">
                            <div class="w-100">
                                <v-select dir="rtl" v-model="taskNoteModel.taskNoteTypeId" label="title" placeholder="نوع یادداشت" :filterable="TaskNoteTypeList.length>10" :options="TaskNoteTypeList" :reduce="p => p.taskNoteTypeId">
                                    <template v-slot="option">
                                        <div class="d-center">
                                            {{ option.title }}
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>

                    <div class="mb-3">
                        <!--@option:cleared="ChangeWorkGroup"-->
                        <v-select dir="rtl" label="title" placeholder="کارگروه" :filterable="WorkGroupList.length>10" :searchable="WorkGroupList.length>10" :options="WorkGroupList" :reduce="p => p.workGroupId" v-model="taskNoteModel.workGroupId" @option:selected="onChangeWorkGroup">
                            <template slot="option">
                                <div class="d-center">
                                    {{ option.title }}
                                </div>
                            </template>
                        </v-select>
                    </div>
                    <div class="mb-3">
                        <v-select dir="rtl" label="title" placeholder="منشن" multiple chips :options="LocalUserListForMention" :reduce="p => p.userId" v-model="taskNoteModel.mentionUserIdsList">
                            <template slot="option">
                                <div class="d-center">
                                    {{ option.title }}
                                </div>
                            </template>
                        </v-select>
                    </div>
                    <div class="mb-3" id="drpUserId" style="display:none">
                        <div class="d-flex">
                            <div class="w-100">
                                <v-select dir="rtl" v-model="taskNoteModel.userId" label="title" placeholder="یادداشت برای" :filterable="localUserListList.length>10" :searchable="localUserListList.length>10" :options="localUserListList" :reduce="p => p.userId">
                                    <template v-slot="option">
                                        <div class="d-center">
                                            {{ option.title }}
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                        <p class="text-danger" v-if="v$.taskNoteModel.userId.required.$invalid && v$.taskNoteModel.userId.$dirty">لطفا یادداشت برای را انتخاب کنید.</p>
                    </div>

                    <div class="mb-3" v-if="!isMinVersion">
                        <div class="d-flex">
                            <div class="w-100">
                                <v-select dir="rtl" v-model="taskNoteModel.personId" label="title" @option:selected="onchangePerson" placeholder="شخص/شرکت" :filter="PersonFilter" :options="PersonList" :reduce="p => p.personId">
                                    <template v-slot="option">
                                        <div class="d-center">
                                            {{ option.title }}
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <div class="d-flex">
                            <div class="w-100">
                                <v-select dir="rtl" v-model="taskNoteModel.projectId" label="fullTitle" @option:selected="onchangeProject" placeholder="پروژه" :filter="ProjectFilter" :options="ProjectList" :reduce="p => p.projectId">
                                    <template v-slot="option">
                                        <div class="d-center">
                                            {{ option.fullTitle }}
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3" v-if="(!isMinVersion) && HasCom">
                        <div class="d-flex">
                            <div class="w-100">
                                <v-select dir="rtl" v-model="taskNoteModel.preInvoiceId" label="strDocNo" @option:selected="onchangePreInvoice" placeholder=" پیش فاکتور فروش کالا/خدمات" :filter="PreInvoiceFilter" :options="PreInvoiceList" :reduce="p => p.preInvoiceId">
                                    <template v-slot="option">
                                        <div class="d-center">
                                            <span>{{  option.strDocNo }}</span>
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3" v-if="!isMinVersion">
                        <div class="d-flex">
                            <div class="w-100">
                                <v-select dir="rtl" v-model="taskNoteModel.contractId" label="strDocNo" @option:selected="onchangeContract" placeholder="قرارداد" :filter="ContractFilter" :options="ContractList" :reduce="p => p.contractId">
                                    <template v-slot="option">
                                        <div class="d-center">
                                            <span>{{  option.strDocNo }}</span>
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3" v-if="!isMinVersion">
                        <div class="d-flex">
                            <div class="w-100">
                                <v-select dir="rtl" v-model="taskNoteModel.meetingId" label="strDocNo" @option:selected="onchangeMeeting" placeholder="جلسه" :filter="MeetingFilter" :options="MeetingList" :reduce="p => p.meetingId">
                                    <template v-slot="option">
                                        <div class="d-center">
                                            <span>{{  option.strDocNo }}</span>
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3" v-if="!isMinVersion">
                        <div class="d-flex">
                            <div class="w-100">
                                <v-select dir="rtl" v-model="taskNoteModel.letterId" label="strDocNo" @option:selected="onchangeLetter" placeholder="نامه" :filter="LetterFilter" :options="LetterList" :reduce="p => p.letterId">
                                    <template v-slot="option">
                                        <div class="d-center">
                                            <span>{{  option.strDocNo }}</span>
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3" v-if="(!isMinVersion) && HasCom">
                        <div class="d-flex">
                            <div class="w-100">
                                <v-select dir="rtl" v-model="taskNoteModel.invoiceId" label="strDocNo" @option:selected="onchangeInvoice" placeholder="فاکتور فروش کالا/خدمات" :filter="InvoiceFilter" :options="InvoiceList" :reduce="p => p.invoiceId">
                                    <template v-slot="option">
                                        <div class="d-center">
                                            <span>{{  option.strDocNo }}</span>
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>




                    <div class="mb-3" v-if="(!isMinVersion) && HasCom">
                        <div class="d-flex">
                            <div class="w-100">
                                <v-select dir="rtl" v-model="taskNoteModel.buyId" label="strDocNo" @option:selected="onchangeBuy" placeholder="خرید کالا/خدمات" :filter="BuyFilter" :options="BuyList" :reduce="p => p.buyId">
                                    <template v-slot="option">
                                        <div class="d-center">
                                            <span>{{  option.strDocNo }}</span>
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>






                    <div class="card mx-0 mb-2">
                        <div class="list-group list-custom-small list-icon-0 bg-blue1-dark px-2 collapse-description-box">
                            <button data-toggle="collapse" data-target="#collapse-description">
                                <i class="fa fa-edit mt-2"></i>
                                <span>توضیحات</span>
                                <i class="fa fa-angle-down"></i>
                            </button>
                        </div>
                        <div class="collapse collapse-reminderCalendars show" id="collapse-description">
                            <textarea v-model="taskNoteModel.description" class="form-control line-height-m text-justify rounded-sm" rows="3" style="height:200px" @keyup="modified=true"></textarea>

                        </div>
                    </div>
                    <button class="btn btn-link speechToTextBtn mb-2" @pointerdown="startR"
                            @pointerup="stopR">
                        <span :class="btnRecord">
                            <span class="speechToTextBtn-text" v-if="showType">شروع به صحبت کنید...</span>
                        </span>
                        <img class="ml-3" v-if="showType" src="/assets/images/wave.gif" width="38" height="38" />
                    </button>
                    <att-list v-if="taskNoteModel.noteId!=0" v-bind:destination="'TaskNote'" @setAttList="SetAttList($event)" :canAdd="true" :canDelete="true" :oldAttList="taskNoteModel.attList" :hasLocation="true"></att-list>

                    <button type="button" :disabled="Loading || attInProgress" class="btn btn-xxs mt-2 mb-3 btn-full bg-green1-dark rounded-sm font-900 w-100" @click.prevent="CreateTaskNote">
                        <i class="fa fa-check font-10 ml-2"></i>
                        ثبت
                    </button>
                    <button type="button" :disabled="Loading || attInProgress" class="btn btn-xxs mt-2 mb-4 btn-full bg-highlight rounded-sm font-900 w-100" @click.prevent="Share">
                        <i class="fa fa-share-alt font-10 ml-2"></i>
                        اشترک گذاری
                    </button>
                </div>
            </div>
        </div>
        <date-picker type="datetime" v-model="taskNoteModel.createDateTime" :auto-submit="true" format="jYYYY/jMM/jDD HH:mm" element="endDT" :jumpMinute="5" />
        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
                <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>درحال ارسال اطلاعات ...</div>
            </div>
        </transition>



    </div>
</template>
<script>
    import useVuelidate from '@vuelidate/core'
    import {
        required
    } from "@vuelidate/validators";
    import 'vue-select/dist/vue-select.css';
    import { maska } from 'maska'
    import AttList from '../Components/AttList.vue';
    import DatePicker from 'vue3-persian-datetime-picker';
    import VueSimpleAlert from 'vue3-simple-alert';
    const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition
    export default {
        components: {
            DatePicker,
            "att-list": AttList,

        },
        setup: () => ({ v$: useVuelidate() }),
        data() {
            return {
                attInProgress: false,
                modified: false,
                showType: false,

                sr: null,
                btnRecord: "btn btn-danger speechToTextBtn-i",
                taskNoteModel: {

                    title: null,
                    noteId: 0,
                    userId: 0,
                    leadId: null,
                    taskNoteTypeId: null,
                    noticeTemplate: false,
                    description: " ",
                    createDateTime: null,
                    attList: [],

                    mentionUserIdsList: [],

                    workGroupId: null,//
                    personId: null,//
                    projectId: null,//
                    invoiceId: null,//
                    preInvoiceId: null,//
                    contractId: null,//
                    letterId: null,//
                    meetingId: null,//
                    preBuyInvoiceId: null,
                    buyId: null,//


                    projectTitle: null,
                    preInvoiceTitle: null,
                    invoiceTitle: null,
                    letterTitle: null,
                    buyTitle: null,
                    contractTitle: null,
                    personTitle: null,
                    meetingTitle: null,
                    preBuyInvoiceTitle: null,
                    leadTitle: null,
                    isLoad: false,
                },

            };
        },
        computed: {
            Loading() {
                return this.$store.getters.GetLoading;
            },
            localUserListList() {
                return this.$store.getters.GetLocalUserListList;
            },

            TaskNoteTypeList() {
                return this.$store.getters.GetTaskNoteTypeList;
            },


            PersonList() {
                return this.$store.getters.GetPersonList;
            },
            ProjectList() {
                return this.$store.getters.GetProjectList;
            },
            PreInvoiceList() {
                return this.$store.getters.GetPreInvoiceList;
            },
            ContractList() {
                return this.$store.getters.GetContractList;
            },
            InvoiceList() {
                return this.$store.getters.GetInvoiceList;
            },
            LetterList() {
                return this.$store.getters.GetLetterList;
            },
            MeetingList() {
                return this.$store.getters.GetMeetingList;
            },
            PreBuyInvoiceList() {
                return this.$store.getters.GetPreBuyInvoiceList;
            },
            BuyList() {
                return this.$store.getters.GetBuyList;
            },
            LocalUserListForMention() {
                return this.$store.getters.GetLocalUserListForMention;
            },
            WorkGroupList() {
                return this.$store.getters.GetWorkGroupList;
            },
            HasCom() {
                return this.$store.getters.GetHasCom;
            },
        },
        watch: {
            localUserListList: {
                //handler: function () {
                //}
            },
            'taskNoteModel.workGroupId'(value) {
                if (this.taskNoteModel.isLoad)
                    this.onChangeWorkGroup();
            },
            'taskNoteModel.personId'(value) {
                if (this.taskNoteModel.isLoad)
                    this.onchangePerson();
            },
            'taskNoteModel.projectId'(value) {
                if (this.taskNoteModel.isLoad)
                    this.onchangeProject();
            },
            'taskNoteModel.preInvoiceId'(value) {
                if (this.taskNoteModel.isLoad)
                    this.onchangePreInvoice();
            },
            'taskNoteModel.contractId'(value) {
                if (this.taskNoteModel.isLoad)
                    this.onchangeContract();
            },
            'taskNoteModel.meetingId'(value) {
                if (this.taskNoteModel.isLoad)
                    this.onchangeMeeting();
            },
            'taskNoteModel.invoiceId'(value) {
                if (this.taskNoteModel.isLoad)
                    this.onchangeInvoice();
            },
            'taskNoteModel.letterId'(value) {
                if (this.taskNoteModel.isLoad)
                    this.onchangeLetter();
            },
            'taskNoteModel.buyId'(value) {
                if (this.taskNoteModel.isLoad)
                    this.onchangeBuy();
            },
        },
        created() {
            this.GetTaskNoteItem();
            this.$store.dispatch("GetTaskNoteTypeListFromServer");
            this.getUserList();
        },
        methods: {
            PersonFilter(item, queryText, itemText) {
                if (queryText.length > 3)
                    this.$store.dispatch("GetPersonListFromServer", {
                        text: queryText,
                    });
                return this.$store.getters.GetPersonList;
            },
            onchangePerson() {
                this.taskNoteModel.projectId = null;
                this.taskNoteModel.invoiceId = null;
                this.taskNoteModel.preInvoiceId = null;
                this.taskNoteModel.contractId = null;
                this.taskNoteModel.letterId = null;
                this.taskNoteModel.meetingId = null;
                this.taskNoteModel.preBuyInvoiceId = null;
                this.taskNoteModel.buyId = null;
                this.$store.dispatch("GetProjectListFromServer", {
                    personId: this.taskNoteModel.personId,
                });
                this.$store.dispatch("GetPreInvoiceAbstractForPerson", {
                    personId: this.taskNoteModel.personId,
                });
                this.$store.dispatch("GetContractAbstractForPerson", {
                    personId: this.taskNoteModel.personId,
                });
                this.$store.dispatch("GetInvoiceAbstractForPerson", {
                    personId: this.taskNoteModel.personId,
                });
                this.$store.dispatch("GetLetterAbstractForPerson", {
                    personId: this.taskNoteModel.personId,
                });
                this.$store.dispatch("GetMeetingAbstractForPerson", {
                    personId: this.taskNoteModel.personId,
                });
                this.$store.dispatch("GetBuyAbstractForPerson", {
                    personId: this.taskNoteModel.personId,
                });
            },


            ProjectFilter(item, queryText, itemText) {
                if (queryText.length > 3)
                    this.$store.dispatch("GetProjectListFromServer", {
                        text: queryText,
                        personId: this.taskNoteModel.personId,
                    });
                return this.$store.getters.GetProjectList;
            },
            onchangeProject() {
                this.taskNoteModel.contractId = null;
                this.taskNoteModel.meetingId = null;
                this.$store.dispatch("GetContractAbstractForPerson", {
                    text: "",
                    personId: this.taskNoteModel.personId,
                    projectId: this.taskNoteModel.projectId,
                });
                this.$store.dispatch("GetMeetingAbstractForPerson", {
                    personId: this.taskNoteModel.personId,
                    projectId: this.taskNoteModel.projectId,
                });
            },


            PreInvoiceFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetPreInvoiceAbstractForPerson", {
                        text: queryText,
                        personId: this.taskNoteModel.personId,
                        projectId: this.taskNoteModel.projectId,
                    });
                return this.$store.getters.GetPreInvoiceList;
            },
            onchangePreInvoice() {
                //this.taskNoteModel.contractId = null;
                this.taskNoteModel.invoiceId = null;
                this.$store.dispatch("GetInvoiceAbstractForPerson", {
                    text: "",
                    preInvoiceId: this.taskNoteModel.preInvoiceId,
                    contractId: this.taskNoteModel.contractId,
                    personId: this.taskNoteModel.personId,
                });
            },



            ContractFilter(item, queryText, itemText) {
                if (queryText.length > 3)
                    this.$store.dispatch("GetContractAbstractForPerson", {
                        text: queryText,
                        personId: this.taskNoteModel.personId,
                    });
                return this.$store.getters.GetContractList;
            },
            onchangeContract() {
                this.taskNoteModel.invoiceId = null;
                this.taskNoteModel.buyId = null;
                this.taskNoteModel.meetingId = null;
                this.$store.dispatch("GetInvoiceAbstractForPerson", {
                    text: "",
                    preInvoiceId: this.taskNoteModel.preInvoiceId,
                    contractId: this.taskNoteModel.contractId,
                    personId: this.taskNoteModel.personId,
                });
                this.$store.dispatch("GetMeetingAbstractForPerson", {
                    personId: this.taskNoteModel.personId,
                    projectId: this.taskNoteModel.projectId,
                    contractId: this.taskNoteModel.contractId,
                });
                this.$store.dispatch("GetBuyAbstractForPerson", {
                    personId: this.taskNoteModel.personId,
                    prebuyInvoiceId: this.taskNoteModel.prebuyInvoiceId,
                    contractId: this.taskNoteModel.contractId,
                });

            },



            InvoiceFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetInvoiceAbstractForPerson", {
                        text: queryText,
                        preInvoiceId: this.taskNoteModel.preInvoiceId,
                        contractId: this.taskNoteModel.contractId,
                        personId: this.taskNoteModel.personId,
                    });
                return this.$store.getters.GetInvoiceList;
            },
            onchangeInvoice() {
                console.log("")
            },



            LetterFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetLetterAbstractForPerson", {
                        text: queryText,
                        letterId: this.taskNoteModel.letterId,
                        personId: this.taskNoteModel.personId,
                    });
                return this.$store.getters.GetLetterList;
            },
            onchangeLetter() {
                console.log("")
            },



            MeetingFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetMeetingAbstractForPerson", {
                        text: queryText,
                        personId: this.taskNoteModel.personId,
                        contractId: this.taskNoteModel.contractId,
                        projectId: this.taskNoteModel.projectId,
                    });
                return this.$store.getters.GetMeetingList;
            },
            onchangeMeeting() {
                console.log("")
            },

            BuyFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetBuyAbstractForPerson", {
                        text: queryText,
                        personId: this.taskNoteModel.personId,
                        prebuyInvoiceId: this.taskNoteModel.prebuyInvoiceId,
                        contractId: this.taskNoteModel.contractId,
                    });
                return this.$store.getters.GetBuyList;
            },
            onchangeBuy() {
                console.log("")
            },




            onChangeWorkGroup() {
                this.taskNoteModel.mentionUserIdsList = [];
                this.taskNoteModel.userId = null;
                this.$store.dispatch("GetLocalUserListListFromServer", {
                    workGroupId: this.taskNoteModel.workGroupId
                });
                this.$store.dispatch("GetLocalUserListForMention", {
                    workGroupId: this.taskNoteModel.workGroupId
                });
            },
            startR() {
                try {
                    this.sr.start();
                    this.showType = true;
                    this.btnRecord = "btn btn-success speechToTextBtn-i-L";
                } catch (error) {
                    console.error(error);
                    this.showType = true;
                    // Expected output: ReferenceError: nonExistentFunction is not defined
                    // (Note: the exact output may be browser-dependent)
                }

            },
            stopR() {
                try {
                    this.sr.stop();
                    this.showType = false;
                    this.btnRecord = "btn btn-danger speechToTextBtn-i";
                } catch (error) {
                    console.error(error);
                    this.showType = false;
                    // Expected output: ReferenceError: nonExistentFunction is not defined
                    // (Note: the exact output may be browser-dependent)
                }
            },
            getUserList() {
                this.$store.dispatch("GetLocalUserListListFromServer", {});
                this.$http.get("Task/TaskOnline_GetUserActiveStatus")
                    .then(data => {
                        if (data.data.expired)
                            document.querySelectorAll("#drpUserId").forEach(a => a.style.display = "none");
                        else {

                            setTimeout(function () {
                                document.querySelectorAll("#drpUserId").forEach(a => a.style.display = "block");
                            }, 1000)
                        }
                    });
            },
            CreateTaskNote() {

                this.v$.$touch(); //it will validate all fields
                if (!this.v$.$invalid) { //invalid, becomes true when a validations return false
                    this.modified = false;
                    this.$store.dispatch("CreateTaskNote", this.taskNoteModel);
                    this.modified = false;
                }

            },
            GetTaskNoteItem() {
                this.$http.get("TaskNote/GetTaskNoteItem?id=" + this.$route.params.noteId)
                    .then(data => {
                        this.$store.dispatch("GetPersonListFromServer", {
                            text: "",
                            personId: data.data.personId,
                        }).then(a => {

                            this.$store.dispatch("GetProjectListFromServer", {
                                text: "",
                                personId: data.data.personId,
                                projectId: data.data.projectId,
                            }).then(b => {
                                this.$store.dispatch("GetPreInvoiceAbstractForPerson", {
                                    text: "",
                                    personId: data.data.personId,
                                    preInvoiceId: data.data.preInvoiceId,
                                }).then(c => {
                                    this.$store.dispatch("GetContractAbstractForPerson", {
                                        personId: data.data.personId,
                                        projectId: data.data.projectId,
                                        contractId: data.data.contractId,
                                    }).then(d => {
                                        this.$store.dispatch("GetInvoiceAbstractForPerson", {
                                            invoiceId: data.data.invoiceId,
                                            preInvoiceId: data.data.preInvoiceId,
                                            contractId: data.data.contractId,
                                            personId: data.data.personId,
                                        }).then(e => {
                                            this.$store.dispatch("GetLetterAbstractForPerson", {
                                                letterId: data.data.letterId,
                                                personId: data.data.personId,
                                            }).then(f => {
                                                this.$store.dispatch("GetMeetingAbstractForPerson", {
                                                    personId: data.data.personId,
                                                    contractId: data.data.contractId,
                                                    projectId: data.data.projectId,
                                                    meetingId: data.data.meetingId,
                                                }).then(g => {
                                                    this.$store.dispatch("GetBuyAbstractForPerson", {
                                                        personId: data.data.personId,
                                                        prebuyInvoiceId: data.data.prebuyInvoiceId,
                                                        buyId: data.data.buyId,
                                                        contractId: data.data.contractId,
                                                    }).then(h => {
                                                        this.$store.dispatch("GetWorkGroupListFromServer", {
                                                            workGroupId: data.data.workGroupId
                                                        }).then(i => {
                                                            this.$store.dispatch("GetLocalUserListListFromServer", {
                                                                workGroupId: data.data.workGroupId
                                                            }).then(j => {

                                                                this.$store.dispatch("GetLocalUserListForMention", {
                                                                    workGroupId: data.data.workGroupId
                                                                }).then(k => {
                                                                    this.taskNoteModel = data.data;
                                                                    this.$http.get("Task/TaskOnline_GetUserActiveStatus")
                                                                        .then(data => {
                                                                            if (data.data.expired)
                                                                                document.querySelectorAll("#drpUserId").forEach(a => a.style.display = "none");
                                                                            this.taskNoteModel.isLoad = true;
                                                                        });
                                                                });
                                                            });
                                                        });
                                                    });
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        });
                        this.modified = false
                    });
            },
            Share() {

                VueSimpleAlert.confirm("آیا مایل به اشتراک گذاری این یادداشت هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
                    this.modified = true;
                    var data = {
                        shareDoc: 1,
                        id: this.taskNoteModel.noteId
                    };
                    this.$http.post("TaskNote/ShareDoc", data)
                        .then(data => {
                            this.modified = false;
                            var res = data.data;
                            if (res.isSuccess) {
                                window.open(res.obj, '_blank');
                            } else {
                                this.showErrorMessage(res.message);
                            }
                        });
                });
            },
            getServerDateTime() {
                this.$http.get("Task/GetServerDateTime")
                    .then(data => {
                        this.taskNoteModel.createDateTime = data.data.replace("_", " ");
                    });

            },
            SetAttList(e) {
                console.log(e);
                this.taskNoteModel.attList = e;
            },
            AttInProgress(e) {
                this.attInProgress = e;
            },
            pauseVid(id) {
                console.log(id);
                if (id != null) {
                    console.log("pause");
                    var vid = document.getElementById(id);
                    vid.pause();
                }
            },
        },
        mounted() {
            try {
                this.sr = new Recognition()
                this.sr.continuous = true
                this.sr.interimResults = true
                this.sr.lang = 'fa-IR';
                var rest = "";
                this.sr.onstart = () => {
                    this.showType = true;
                    this.btnRecord = "btn btn-success speechToTextBtn-i-L";
                }
                this.sr.onresult = (evt) => {
                    rest = evt.results[evt.results.length - 1][0].transcript;
                }
                this.sr.onend = () => {
                    if (this.taskNoteModel.description == null || this.taskNoteModel.description == "null")
                        this.taskNoteModel.description = "";
                    this.taskNoteModel.description = this.taskNoteModel.description + " " + rest
                    this.btnRecord = "btn btn-danger speechToTextBtn-i";
                    this.showType = false;
                }
            } catch (error) {
                console.error(error);
            }
            document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
        },
        validations: {
            taskNoteModel: {
                title: {
                    required,
                },
                userId: {
                    required,
                }
            }


        },
        directives: { maska },
        beforeRouteLeave(to, from, next) {
            if (this.modified == true) {
                VueSimpleAlert.fire({
                    title: 'با بستن این صفحه تغییرات شما ذخیره نخواهد شد. آیا ادامه می دهید؟',
                    showCancelButton: true,
                    confirmButtonText: 'تأیید',
                    cancelButtonText: `انصراف`,
                }).then((result) => {
                    console.log(this.modified);

                    if (result.value == true) {
                        next();
                    } else {
                        next(false);
                    }
                })
            }
            else {
                next();
            }
        }
    };
</script>
